import _ from 'underscore'
import {getLocalStorage} from '../../util/LocalStorage'

/**
 * Group tasks by workflow status for every project
 * @param projects ordered projects
 * @param customers for fill names
 * @param tasks all tasks
 * @param editableProjectIds for fill possible actions
 * @param editableProjectIdsWithExcludeSelf for fill possible actions
 * @param editableCustomerIds for fill possible actions
 * @param editableCustomerIdsWithExcludeSelf for fill possible actions
 * @returns {*}
 */
export function calcProjectsWithGroupedTasks(projects, customers, tasks, editableProjectIds, editableProjectIdsWithExcludeSelf, editableCustomerIds, editableCustomerIdsWithExcludeSelf) {
    return projects.map(project => {
        const tasksByStatus = _.groupBy(tasks.filter(task => task.projectId === project.id), 'workflowStatusId')
        return {
            ...project,
            tasksByStatus,
            canReopenProject: !!editableProjectIds[project.id] && !customers[project.customerId].archived || !!editableCustomerIds[project.customerId],
            canManageAllProjectTasks: !!editableProjectIdsWithExcludeSelf[project.id] || !!editableCustomerIdsWithExcludeSelf[project.customerId],
        }
    })
}

/**
 * Filter all projects and get only rendered on page
 * TODO when all projects collapsed - returns all projects together that may produce performance issues
 * @param allProjects
 * @param isProjectCollapsedPredicate check project collapsed
 * @param projectLoadingPositions check that projects fully loaded
 * @param isProjectVisiblePredicate check that project is possible to see on page
 * @returns {Array}
 */
export function filterVisibleProjects(allProjects, isProjectCollapsedPredicate, projectLoadingPositions, isProjectVisiblePredicate) {
    // fill projects from start to first expanded not fully loaded
    const targetProjects = []
    for (let i = 0; i < allProjects.length; i++) {
        const project = allProjects[i]

        const {id} = project
        const collapsed = isProjectCollapsedPredicate(id)
        const fullyLoaded = isProjectFullyLoaded(id, projectLoadingPositions)
        
        if (isProjectVisiblePredicate(id)) {
            targetProjects.push(project)

            if (!collapsed && !fullyLoaded) {
                // it's last project that we should see
                break
            }
        }
    }
    return targetProjects
}

export function isProjectFullyLoaded(projectId, projectLoadingPositions) {
    return !!(projectLoadingPositions[projectId] && projectLoadingPositions[projectId].fullyLoaded)
}

const KANBAN_COLLAPSED_PROJECTS_STATE_LS_KEY = 'kanbanCollapsedProjectsState'

export function storeCollapsedProjectsState(collapsedProjects) {
    getLocalStorage().setItem(KANBAN_COLLAPSED_PROJECTS_STATE_LS_KEY, collapsedProjects)
}

export function getStoredCollapsedProjectsState() {
    return getLocalStorage().getItem(KANBAN_COLLAPSED_PROJECTS_STATE_LS_KEY)
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/kanban/utils.js